import type { FC } from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'

import { useEventListener } from '@/hooks/useEventListener'
import type { WidgetMessages } from '@/models/types'

type BookingWidgetProps = {
  config: {
    apiToken: string
    mode: string
    integrationType: string
    theme?: string
    language?: string
  }
}

const BookingWidget: FC<BookingWidgetProps> = (props) => {
  const { config } = props
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [iframeHeight, setIframeHeight] = useState<number>(0)

  const setupIframe = useCallback(() => {
    const iframe = iframeRef.current
    const iframeParams = new URLSearchParams(config).toString()

    if (!iframe) throw new Error('Iframe not found')

    iframe.src = `${import.meta.env.VITE_BOOKING_WIDGET_URL}/v2/booking/?${iframeParams}`

    return iframe
  }, [config])

  useEffect(() => {
    const iframe = setupIframe()

    return () => {
      if (iframe) {
        iframe.src = ''
      }
    }
  }, [setupIframe])

  const handleEventMessage = (event: MessageEvent<WidgetMessages>) => {
    if (event.data?.type === 'resize') {
      const containerPaddingsY = 90
      const fullDvh = window.innerHeight - containerPaddingsY

      if (event.data.message.height > fullDvh) {
        setIframeHeight(event.data.message.height)
      } else {
        setIframeHeight(fullDvh)
      }
    }
  }

  useEventListener('message', handleEventMessage)

  return (
    <iframe
      data-hj-allow-iframe="true"
      title="Dentech.se Booking widget"
      id="tdl-booking-widget"
      ref={iframeRef}
      style={{
        maxWidth: '971px',
        width: '100%',
        height: `${iframeHeight}px`,
        border: 'none',
      }}
    />
  )
}

export default BookingWidget
